export default __webpack_public_path__ + "static/1233-981e4e469c9b6835b0b289716af9972f.gif";